import { CheckCircleSharp } from '@mui/icons-material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import about from '../assets/about-bg-1.webp';

const AboutSection = () => {
    return (
        <Box
            sx={{
                width: '100%',
                backgroundImage: `url(${about})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                py: 8,
                fontFamily: 'Rajdhani, sans-serif',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: 'center',
                    justifyContent: 'center',
                    px: { xs: 2, sm: 3 },
                    mx: 'auto',
                    // mt:'40px',
                    fontFamily: 'Nunito, sans-serif',
                    width: {
                    xs: '95%',
                    sm: '100%',
                    md: '100%',
                    lg: '85%',
                    xl: '85%',
                },
                }}
                maxWidth="lg"
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    {/* Left Image */}
                    <Box
                        component="img"
                        src="https://ittech.ditsolution.net/wp-content/uploads/2024/09/about7.png"
                        alt="About"
                        sx={{
                            width: '40%',
                            height: '50%',
                            borderRadius: 2,
                            display: { xs: 'none', md: 'block' },
                        }}
                    />

                    {/* Right Content */}
                    <Box
                        sx={{
                            width: { xs: '100%', md: '50%' },
                            mt: { xs: 4, md: 0 },
                        }}
                    >
                        <Typography
                            variant="h5"
                            sx={{
                                fontFamily: 'Rajdhani',
                                fontWeight: 600,
                                fontSize: '19px',
                                color: '#0c5adb',
                            }}
                        >
                            WHO WE ARE
                        </Typography>
                        <Typography
                            variant="h2"
                            sx={{
                                fontFamily: 'Rajdhani',
                                color: '#232323',
                                fontWeight: 'bold',
                                lineHeight: 1.2,
                            }}
                        >
                            Get Exclusive It Solutions &
                            <br />
                            Services With  <span style={{ color: '#075AD6' }}>Loopsys</span>
                        </Typography>

                        <Typography fontSize={'13px'} color="#686868" fontFamily={'Nunito'} my={'20px'}>
                            Empower your business with cutting-edge IT solutions tailored to your unique needs.
                            At Loopsys Technologies, we blend innovation with expertise to deliver reliable,
                            future-ready technology services that help your business grow and thrive.
                        </Typography>

                        <Box sx={{ mt: 3, fontSize: '16px', fontFamily: 'roboto', color: "#041424" }}>
                            {['High-quality solutions', 'Expert team support', 'Customer-centric approach'].map((point, i) => (
                                <Box key={i} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <CheckCircleSharp sx={{ color: '#075AD6', mr: 1 }} />
                                    <Typography variant="body1" fontWeight={300}>
                                        {point}
                                    </Typography>
                                </Box>
                            ))}
                        </Box>

                        <Button
                            sx={{
                                mt: '50px',
                                position: 'relative',
                                overflow: 'hidden',
                                borderRadius: '3px',
                                px: '10px',
                        py: '3px',
                                textTransform: 'uppercase',
                                fontWeight: 600,
                                fontFamily: 'Rajdhani',
                                fontSize: '17px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1.5,
                                backgroundColor: '#0c5ADB',
                                color: '#fff',
                                border: '2px solid #0c5ADB',
                                width: 'fit-content',
                                transition:
                                    'color 0.4s ease-in-out, background-color 0.4s ease-in-out',

                                '& span, & .arrow-circle': {
                                    position: 'relative',
                                    zIndex: 1,
                                },

                                '&::before': {
                                    content: '""',
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    height: '100%',
                                    width: '100%',
                                    backgroundColor: '#fff',
                                    zIndex: 0,
                                    transform: 'translateX(100%)',
                                    transition: 'transform 0.4s ease-in-out',
                                },

                                '&:hover::before': {
                                    transform: 'translateX(0%)',
                                },

                                '&:not(:hover)::before': {
                                    transform: 'translateX(-100%)',
                                },

                                '& .arrow-circle': {
                                    backgroundColor: '#fff',
                                    color: '#075AD6',
                                    borderRadius: '50%',
                                    padding: '3px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'all 0.4s ease-in-out',
                                },

                                '&:hover': {
                                    color: '#075AD6',
                                    '& .arrow-circle': {
                                        backgroundColor: '#0c5ADB',
                                        color: '#fff',
                                    },
                                },
                            }}
                            component={Link} to="/about-us"
                        >
                            <span>ABOUT US</span>
                            <span className="arrow-circle">
                                <ArrowForwardIcon fontSize="small" />
                            </span>
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default AboutSection;
